<template>
    <Content style="background:rgba(249,249,249,1);">
        <div class="bgServices"></div>
        <div class="tabs-wrap">
            <ul class="nav-tabs">
                <li class="tab-item" @click="selectTab(index,item.columnId)" :class=" { active: currentTabIndex==index} " v-for="(item,index) in columnList" :key="index">{{item.title}}</li>
            </ul>
            <ul class="tabs-content">
                <div class="text" style="line-height: 1.5">
                    <div v-html="columnDetail.content"></div>
                </div>
            </ul>
        </div>
    </Content>
</template>

<script>

    import api from '@/api/api'

    export default {
        name: 'service',
        data(){
          return{
              currentTabIndex: '',
              columnList: '',
              columnId: '',
              columnDetail: '',
              name: '',
          }
        },
        activated(){
            this.columnId = this.$route.params.columnId;
            this.currentTabIndex = this.$route.params.index;
            this.getColumnList(this.columnId);
        },
        methods:{
            getColumnList(columnId){
                var _this = this;
                api.columnLists().then(res => {
                    _this.columnList = res;
                    if (columnId == null) {
                        columnId = res[0].columnId;
                    }
                    api.columnDetail(columnId).then(res => {
                        _this.columnDetail = res;
                    }).catch(error =>{
                        this.$Message.error('列表数据获取错误')
                    });
                }).catch(error =>{
                    this.$Message.error('分类数据获取错误')
                });
            },
            selectTab(index,columnId){
                var _this = this;
                this.currentTabIndex = index;
                api.columnDetail(columnId).then(res => {
                    _this.columnDetail = res;
                }).catch(error => {
                    this.$Message.error('列表数据获取错误')
                });
            },
        },
        components: {}
    }
</script>

<style lang="scss">
    .layout {
        background: #f5f7f9;
        position: relative;
        overflow: hidden;
    }

    .bgServices {
        width: 100%;
        height: 280px;
        background: url("../assets/bannner1.png") no-repeat center;
        background-size: cover;
        -webkit-background-size: cover;
        -moz-background-size: cover;
    }

    .tabs-wrap{
        margin: 0px auto 10px;
        .nav-tabs{
            width: 100%;
            font-size: 18px!important;
            padding-left: 18%;
            height:60px;
            background:rgba(255,255,255,1);
            box-shadow:0px 2px 2px 0px rgba(4,0,0,0.13);
            .tab-item{
                float: left;
                padding: 10px 18px;
                height: 55px;
                line-height: 50px;
                font-size: 18px;
                &:hover{
                    color: #009DE9;
                    border-color: #009de952;
                    cursor: pointer;
                }
                &.active{
                    color: #009DE9;
                    border-bottom: 2px solid #009DE9;
                }
            }
        }
        .tabs-content{
            .text {
                width: 70%;
                margin: 0px auto;
                padding: 30px;
                text-align: left!important;
                strong {
                    font-weight: bolder!important;
                }
            }
        }
    }
</style>
